import { render, staticRenderFns } from "./archaeologyDatabase.vue?vue&type=template&id=48985db4&scoped=true"
import script from "./archaeologyDatabase.vue?vue&type=script&lang=js"
export * from "./archaeologyDatabase.vue?vue&type=script&lang=js"
import style0 from "./archaeologyDatabase.vue?vue&type=style&index=0&id=48985db4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48985db4",
  null
  
)

export default component.exports